import { OfferPreview } from "@justhome/api-core";
import clsx from "clsx";
import { FC } from "react";
import Badge from "../Badge";
import InfoIcon from "../InfoIcon";
import { Locale } from "../lib/i18n";
import { offerLabels } from "../lib/labels";

interface OfferCombinationInfoProps {
  offer?: OfferPreview;
  className?: string;
  locale: Locale;
}

const OfferCombinationInfo: FC<OfferCombinationInfoProps> = ({
  offer,
  className,
  locale,
}) => {
  const isKfw = offer?.loans?.some((l) => l.type === "KFW_DARLEHEN");
  const labels = offerLabels[locale];
  return (
    <div className={clsx("flex items-center gap-2xs", className)}>
      <Badge size="md">
        <span className="y-2">{labels.combination}</span>
        <InfoIcon>
          {isKfw ? labels.kfwCombination : labels.standardCombination}
        </InfoIcon>
      </Badge>
    </div>
  );
};

export default OfferCombinationInfo;
